export const BASE_URL = process.env.BASE_URL;
export const ENV = process.env.ENV;
